import { Button } from '@leadsnavi/ui-kit';
import cn from 'classnames';

interface ResendButtonProps {
  /** 倒计时剩余秒数（0 表示可以重发） */
  countdown: number;
  /** 格式化后的时间字符串 */
  formattedTime?: string;
  /** 点击回调 */
  onClick?: () => void;
  /** 是否加载中 */
  loading?: boolean;
  /** 自定义类名 */
  className?: string;
}

/**
 * 重发按钮组件（带倒计时）
 */
export function ResendButton({ countdown, formattedTime, onClick, loading = false, className }: ResendButtonProps) {
  const isDisabled = countdown > 0 || loading;
  const displayTime = formattedTime || formatTime(countdown);

  return (
    <Button
      onClick={onClick}
      disabled={isDisabled}
      loading={loading}
      className={cn(
        'h-[40px] w-full rounded-[8px] bg-[#171717] px-[24px] py-[9.5px]',
        'text-[14px] font-medium leading-[1.5] tracking-[0.07px] text-white',
        'hover:bg-[#262626]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
    >
      {isDisabled && countdown > 0 ? `Resend (${displayTime}s)` : 'Resend'}
    </Button>
  );
}

/**
 * 格式化时间
 */
function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

export default ResendButton;
